var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C10.995 0 8.505 2.43833 7.5 7.33333C9 4.895 10.755 3.97833 12.75 4.58333C13.89 4.93167 14.715 5.94 15.615 7.05833C17.085 8.89167 18.75 11 22.5 11C26.505 11 28.995 8.56167 30 3.66667C28.5 6.105 26.745 7.02167 24.75 6.41667C23.61 6.06833 22.8 5.06 21.885 3.94167C20.415 2.10833 18.75 0 15 0ZM7.5 11C3.495 11 1.005 13.4383 0 18.3333C1.5 15.895 3.255 14.9783 5.25 15.5833C6.39 15.9317 7.2 16.94 8.115 18.0583C9.585 19.8917 11.25 22 15 22C19.005 22 21.495 19.5617 22.5 14.6667C21 17.105 19.245 18.0217 17.25 17.4167C16.11 17.0683 15.3 16.06 14.385 14.9417C12.915 13.1083 11.25 11 7.5 11Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.708cdfbe82b4f649fb3e5ef9f24f6d79.svg";
export { ForwardRef as ReactComponent };